// Shared endpoint helper for the Document Vault. On the native app the API
// lives on the deployed site (Netlify Function); on web it's same-origin.

import { isNativeRuntime } from '@/lib/native/platform';

const WEBSITE_ORIGIN = 'https://seamigo.vesselos.in';

export function vaultApiPath(path: string): string {
  return isNativeRuntime() ? `${WEBSITE_ORIGIN}${path}` : path;
}
